<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="addOrEdit" :loading="btnLoading" type="primary">下一步</el-button>
    </div>
    <div>
      <div class="main">
        <el-form :model="ptc" ref="ruleForm" label-position="right" class="mainfrom">
            <div>
                <!-- <div class="row from_input">
                    <el-form-item  label="协议编号" prop="ptccode" verify>
                        <el-input v-model="ptc.ptccode" :maxlength="20"></el-input>
                    </el-form-item>
                </div>
                <div class="row from_input">
                    <el-form-item  label="外部编号" prop="ptcoutcode" verify>
                        <el-input v-model="ptc.ptcoutcode" :maxlength="20"></el-input>
                    </el-form-item>
                </div> -->
                <div class="content-title">
                    <el-form-item  label="协议名称" prop="ptcname" verify>
                        <el-input v-model="ptc.ptcname" :maxlength="128" show-word-limit></el-input>
                    </el-form-item>
                </div>
                <!-- <div class="row from_input">
                    <el-form-item  label="预算金额" prop="projectptel" verify>
                        <el-input v-model="ptc.ptcbudgetamt" :maxlength="20"></el-input>
                    </el-form-item>
                </div> -->
                <div class="row from_input">
                    <el-form-item  label="采购人" prop="ptcpcomname" verify>
                        <div style="width:200px;margin: 0 5px;">{{ptc.ptcpcomname?ptc.ptcpcomname:"请选择"}}</div>
                        <!-- <el-input v-model="ptc.ptcpcomname" :maxlength="20" :disabled="true"></el-input> -->
                        <vxe-button  type="primary" size="small" @click="showCgr" icon="el-icon-search" style="height:38px;"></vxe-button>
                    </el-form-item>
                </div>
                <!-- <div class="row from_input">
                    <el-form-item  label="联系人" prop="ptctpuserid" verify>
                        <el-select v-model="ptc.ptctpuserid">
                            <el-option v-for="(item, index) in auserList" :label="item.label" :value="item.value"
                                    :key="index"></el-option>
                        </el-select>
                        <vxe-button  type="primary" @click="showCglxr" icon="el-icon-search" style="height:38px;"></vxe-button>
                    </el-form-item>
                </div> -->
                <div class="row from_input">
                    <el-form-item  label="联系人" prop="ptctpuserid" verify>
                        <el-select v-model="ptc.ptctpuserid" @change="getpUserTel">
                            <el-option v-for="(item, index) in auserList" :label="item.label" :value="item.value"
                                    :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 弹出框 -->
                    <el-popover
                        placement="right"
                        width="700"
                        trigger="click"
                        @hide="hidePopover"
                        v-model="popflg"
                        @show="showpop">
                        <div>
                            <div style="margin-bottom:20px;">
                                <el-input style="width:80%;margin-right:20px;"
                                    @input="inputchange" v-model="username" placeholder="请输入联系人姓名" clearable/>
                                <el-button  type="primary" @click="getaUserdialogList">搜索</el-button>
                            </div>
                            <vggrid  :random="Math.floor(Math.random() * 999999)" 
                                    :list="auserDList" tableheight="600" flexname="" :cols="Ucols"
                                    :showfooter="false" :showPage="true" :resizable="true"  :defaultPage="5"
                                    :total="Uquery.total" @pagechange="Upagechange" @cellClick="viewProject"
                            >
                                <template slot="btn">
                                    <div class="btn-box">
                                        <vxe-button type="text" icon="el-icon-plus" @click="addUser">
                                            新增
                                        </vxe-button>
                                        <vxe-button type="text" icon="el-icon-edit-outline" @click="chgUser">
                                            修改
                                        </vxe-button>
                                    </div>
                                </template>
                            </vggrid>
                        </div>
                        <el-button slot="reference"  type="primary" size="small" icon="el-icon-search" style="height:38px;"></el-button>
                    </el-popover>
                </div>
                <div class="row from_input">
                    <el-form-item  label="手机">
                        <!-- <el-input v-model="ptc.usermobile" :maxlength="20"></el-input> -->
                        {{ptc.usermobile?ptc.usermobile:'暂无'}}
                    </el-form-item>
                </div>
                <div class="row from_input">
                    <el-form-item  label="电话" >
                        <!-- <el-input v-model="ptc.usertel" :maxlength="20"></el-input> -->
                        {{ptc.usertel?ptc.usertel:'暂无'}}
                    </el-form-item>
                </div>
                <div class="row from_input">
                    <el-form-item  label="邮箱">
                        <!-- <el-input v-model="ptc.useremail" :maxlength="20"></el-input> -->
                        {{ptc.useremail?ptc.useremail:'暂无'}}
                    </el-form-item>
                </div>
                <!-- <div class="row from_input">
                    <el-form-item  label="交易方式" prop="ptctrademode" verify>
                        <el-input v-model="ptc.ptctrademode" :maxlength="20"></el-input>
                    </el-form-item>
                </div>
                <div class="row from_input">
                    <el-form-item  label="协议文本" prop="ptctext" verify>
                        <el-input v-model="ptc.ptctext" :maxlength="20"></el-input>
                    </el-form-item>
                </div>
                <div class="row from_input">
                    <el-form-item  label="协议文件" prop="projectptel" verify>
                        <el-input v-model="ptc.projectptel" :maxlength="20"></el-input>
                    </el-form-item>
                </div> -->
            </div>
        </el-form>
      </div>
    </div>
    <el-dialog
        title="选择采购人"
        :visible.sync="cgrflg"
        width="50%">
        <div style="margin-bottom:20px;">
            <el-input style="width:80%;margin-right:20px;"
                @change="getSearchPcomList" @input="inputchange" v-model="comname" placeholder="请输入采购人名称" clearable/>
            <el-button  type="primary" @click="getSearchPcomList">搜索</el-button>
        </div>
        <vggrid  :random="Math.floor(Math.random() * 999999)" :list="pcomList" tableheight="600" flexname="" :cols="cols"
                :showfooter="false" :showPage="true" :resizable="true"
                :total="query.total" @pagechange="pagechange"
        >
        </vggrid>
    </el-dialog>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import _ from 'lodash'
  import common from '@/mixin/common'
  import vggrid from '../common/vggrid'

  export default {
    name: "ptcform",
    mixins: [common],
    data () {
      return {
            ptc:{},
            btnLoading:false,
            cglxrflg:false,
            cgrflg:false,
            popflg:false,
            comname:'',
            username:'',
            userComid:'',
            auserList:[],//采购人列表
            auserDList:[],
            user:{},
            query: {
                comneme: '',
                total: 0,
                limit: 10,
                offset: 0
            },
            Uquery: {
                username: '',
                total: 0,
                limit: 5,
                offset: 0
            },
            pcomList: [],
            cols:[
                { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
                { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
                { title: '操作 ', showOverflow: true,
                    slots: {
                    default: ({row}) => {
                        return [<vxe-button onClick={this.confirmCom.bind(this, row)}>确认</vxe-button>]
                    }
                    }
                }
            ],
            Ucols:[
                { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
                { field: 'username', fieldtype: 'C', title: '姓名',calculExpr:'',addNewRowFlg: false},
                { field: 'usercode', fieldtype: 'C', title: '手机',calculExpr:'',addNewRowFlg: false},
                { title: '操作 ', showOverflow: true,
                    slots: {
                    default: ({row}) => {
                        return [<vxe-button onClick={this.confirmUser.bind(this, row)}>确认</vxe-button>]
                    }
                    }
                }
            ],
      }
    },
    async created () {
    },
    filters:{
    },
    async mounted () {
      await this.init()
    },
    async activated () {
    //   await this.getptcInfo()
      await this.init()
    },
    components: {vggrid},
    computed: {
    },
    methods: {
        async init(){
            if(this.ptc.ptcpcomname){
                await this.getaUserList()
            }
        },
        async hidePopover(){
            this.user = {}
        },
        async getSearchPcomList(){
            this.query.cosid = this.$store.getters.loginUser.cosid
            this.query.comtype = '2'
            //代理单位
            if (this.$store.getters.loginUser.comtype === '1') {
                this.query.comid = null
            }
            //采购人
            if (this.$store.getters.loginUser.comtype === '2') {
                this.query.comid = this.$store.getters.loginUser.usercomid
            }
            this.query.comcodename = this.comname

            let res = await request({
                method: 'get',
                url: '/ywgl/com/getPageList',
                params: this.query
            })
            this.pcomList = res.list
            this.query.total = res.count[0].count
        },
        async getptcInfo(){
          let data = await request({
            url: '/xmgl/ptc/getptcInfo',
            method: "get",
            params: {ptcid:this.$route.params.ptcid}
          })
        },
        async pagechange (page) {
            this.query.offset = page.pageSize * (page.currentPage - 1)
            this.query.limit = page.pageSize
            this.getSearchPcomList()
        },
        async Upagechange(page){
            this.Uquery.offset = page.pageSize * (page.currentPage - 1)
            this.Uquery.limit = page.pageSize
            this.getaUserdialogList()
        },
        inputchange(e){
            this.comname = e.replace(/[, ]/g,'')
        },
        async showCgr(){
            this.cgrflg = true
            this.getSearchPcomList()
        },
        async viewProject(row) {
            this.user = row.row
        },
        async showCglxr(){
            if(this.ptc.ptcpcomid){
                this.cglxrflg = true
            } else{
                this.$message.warning('请先选择采购人')
                return
            }
        },
        async confirmCom(row){
            this.$set(this.ptc,'ptcpcomname',row.comfullname)
            this.$set(this.ptc,'ptcpcomid',row.comid)
            this.userComid = row.comid
            await this.getaUserList ()
            this.cgrflg = false
        },
        async confirmUser(row){
            let user = this.auserDList.find(item => (item.userid === row.userid))
            this.$set(this.ptc,'ptctpuserid',user.userid)
            this.ptc.useremail = user.username
            this.ptc.usertel = user.usertel
            this.ptc.usermobile = user.usermobile
            this.popflg = false
        },
        async getaUserList () {
            if(this.userComid){
                this.auserList = await request({
                    method: 'get',
                    url: '/xtgl/user/getUserList',
                    params: {comid: this.userComid}
                })
                if(this.auserList.length > 0){
                    this.$set(this.ptc,'ptctpuserid',this.auserList[0].userid)
                    await this.getpUserTel(this.ptc.ptctpuserid)
                }
            }
        },
        async getaUserdialogList () {
            this.user = {}
            this.Uquery.username = this.username
            this.Uquery.comid = this.userComid
            let res = await request({
                method: 'get',
                url: '/xtgl/user/getPageList',
                params: this.Uquery
            })
            this.auserDList = res.list
            this.Uquery.total = res.count[0].count
        },
        async getpUserTel (userid) {
            let user = this.auserList.find(item => (item.userid === userid))
            this.ptc.useremail = user.useremail
            this.ptc.usertel = user.usertel
            this.ptc.usermobile = user.usermobile
        },
        async addOrEdit(){
            this.submitForm('ruleForm').then(async() => {
                this.ptc.ptccosid = this.$store.getters.loginUser.cosid
                this.ptc.ptccreateuserid = this.$store.getters.loginUser.userid
                this.ptc.ptcdptid = this.$store.getters.loginUser.userdptid
                let data = await request({
                    url: '/xmgl/ptc/addOrEdit',
                    method: "post",
                    data: this.ptc
                })
                if(data.issuccess === 1){
                    this.close()
                    this.$refs['ruleForm'].resetFields()
                    this.$message.success('保存成功')
                    this.ptc = {}
                    this.$router.push({name: 'ptcEdit', params: {ptcid: data.data.ptcid}})
                }
            }).catch(() => {
            })
        },
        async addUser(){
            let form = {
                userid: 0,
                cosid:this.$store.getters.loginUser.cosid,
                usercomid: this.ptc.ptcpcomid,
                userstatus: '1',
                comtype:2,
                userlockflg: '1'
            }
            this.$router.push({name: 'userForm', params: {form: form, type: 1}})
        },
        async chgUser(){
            if (!this.user.userid) {
            this.$message.warning('请选择一个用户!')
            return
            }
            this.user.cosid = this.$store.getters.loginUser.cosid,
            this.$router.push({name: 'userForm', params: {form: this.user, type: 2}})
        },
        async showpop(){
            if(this.userComid){
                await this.getaUserdialogList()
                this.popflg = true
            }else{
                this.popflg = false
                this.$message.warning('请先选择采购人')
                return
            }
        },
        close () {
            this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'ptcindex'})
        }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content-title{
      display: flex;
      .el-input{
        width: 514px;
      }
      .el-cascader{
        width: 200px;
      }
    }
    .content .el-textarea__inner, .el-textarea {
      width: 840px;
    }
    .file {
      display: flex;
      flex-direction: column;
      // width: 50%;
      .uploadbtn {
        display: flex;
        span {
          padding-left: 10px;
          color: red;
        }
      }
    }
    .checkbox_w {
      width: 45px;
    }
  }
</style>
